package com.veldekar.components.log

import kotlinx.datetime.LocalDate

/**
 * Sealed class representing session list data.
 * Used by SessionListLinks to render the list of sessions.
 */
sealed class SessionListData {
    abstract val path: String
    abstract val date: LocalDate
    abstract val veldekarDates: List<String>

    /**
     * A simple session with only a date link.
     * Used for sessions without title or description.
     */
    data class Simple(
        override val path: String,
        override val date: LocalDate,
        override val veldekarDates: List<String> = emptyList(),
    ) : SessionListData()

    /**
     * A full session with title, description, and optional image.
     */
    data class Full(
        override val path: String,
        val title: String,
        val description: String,
        val imageUrl: String,
        val imageWidth: Int? = null,
        val imageHeight: Int? = null,
        val isAiText: Boolean = false,
        val isAiImage: Boolean = false,
        val aiHint: String? = null,
        override val date: LocalDate,
        override val veldekarDates: List<String> = emptyList(),
    ) : SessionListData()
}
